import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useIsMobileViewport } from 'app/hooks/useIsMobileViewport';

/**
 * Review & Approval is the only page with a mobile layout, so on a mobile
 * viewport the other nav destinations (Roadmap, Milestones, Must Wins, Saved
 * Views and the moment slide-out over them) redirect once to `/review-approval`.
 * Auth, error, settings and `/review-approval*` routes are left alone.
 */
const REDIRECT_FROM_PATHS = ['/', '/roadmap', '/milestones'];
const REDIRECT_FROM_PREFIXES = ['/moments/', '/milestones/moments/'];

export const MOBILE_HOME_PATH = '/review-approval';

function shouldRedirectToMobileHome(pathname: string): boolean {
  if (pathname.startsWith(MOBILE_HOME_PATH)) return false;
  if (REDIRECT_FROM_PATHS.includes(pathname)) return true;
  return REDIRECT_FROM_PREFIXES.some(prefix => pathname.startsWith(prefix));
}

/** Renders nothing; mounted once inside the router for the effect above. */
export function MobileHomeRedirect() {
  const isMobile = useIsMobileViewport();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMobile) return;
    if (!shouldRedirectToMobileHome(location.pathname)) return;
    navigate(MOBILE_HOME_PATH, { replace: true });
  }, [isMobile, location.pathname, navigate]);

  return null;
}

export default MobileHomeRedirect;
